import type { NavigateOptions, To } from 'react-router-dom'

let navigateRef: ((to: To, options?: NavigateOptions) => void) | null = null

export function setNavigator(navigate: (to: To, options?: NavigateOptions) => void) {
  navigateRef = navigate
}

export function appNavigate(to: To, options?: NavigateOptions) {
  if (navigateRef) {
    navigateRef(to, options)
  } else {
    // Fallback during very early boot
    const href = typeof to === 'string' ? to : String(to)
    window.location.href = href
  }
}


